<style lang="less" scoped>
.td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.after {text-align: left;background-color: #fcfcfc;}
.after .el-button {height: 40px;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.td {margin-left: 10px;}
table {border-collapse: collapse;width: 100%;}
.el-checkbox__inner {border-radius: 50%;}
.first /deep/ .el-input {width: 400px;}
.level /deep/ .el-input {width: 200px;}
.ssgj_tr /deep/ .el-input {width: 400px;}
.edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
.el-form-item {margin-bottom: 0;float: left;}
.jianjie_tr .el-form-item {width: 100%;}
.catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
.tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
/deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
.btnfixed {margin: 0px auto;height: 60px;z-index: 9999;margin-top: 20px;}
.btnfixed .el-button {height: 40px;margin: 10px auto;}
/deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
/deep/.el-icon-close-tip {display: none;}
.sub_table1{width: 400px;text-align:center;
.canshuname{width: 100px !important;}
.canshuvalue{width: 200px !important;}}
.sub_table2{width: 400px;
.first{width: 126px;}
.el-input{width: 100px;margin: 0px 5px;}}
.radio{font-size: 16px;}
#editor {position: relative;z-index: 1;}
#HTkcpeditor {position: relative;z-index: 1;}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="catid_tr" style="height: 42px;">
          <td class="td_left">
            <span v-if="isMandatory('typeid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>信息类型
          </td>
          <td class="after">
            <el-radio v-model="form.typeid" label="1" style="margin-left: 10px;"><span class="radio">供应</span></el-radio>
            <el-radio v-model="form.typeid" label="0"><span class="radio">求购</span></el-radio>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>信息标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入标题" class="input title" @blur="detection(11, 14, form.title)"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="form.level" placeholder="级别" class="select level">
                <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>行业分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.catid" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in classifydata" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('brand')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品品牌
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.brand" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">
            <span v-if="isMandatory('ssgj')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属国家
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.ssgj" placeholder="请选择所属国家" class="select level">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr" style="height: 42px;">
          <td class="td_left">
            <span v-if="isMandatory('kuangchanzhonglei')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>矿产种类
          </td>
          <td class="after">
            <el-radio v-model="form.kuangchanzhonglei" label="稀贵金属" style="margin-left: 10px;"><span class="radio">稀贵金属</span></el-radio>
            <el-radio v-model="form.kuangchanzhonglei" label="有色金属"><span class="radio">有色金属</span></el-radio>
            <el-radio v-model="form.kuangchanzhonglei" label="黑色金属"><span class="radio">黑色金属</span></el-radio>
            <el-radio v-model="form.kuangchanzhonglei" label="非金属"><span class="radio">非金属</span></el-radio>
            <el-radio v-model="form.kuangchanzhonglei" label="其它"><span class="radio">其它</span></el-radio>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('pinwei')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>品位
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.pinwei" placeholder="" class="input title"></el-input>
            </el-form-item>
            <span style="display: inline-block;margin-top: 8px;margin-left: 10px;"></span>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('jiaoyiliang')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>交易量
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.jiaoyiliang" class="input title"></el-input>
            </el-form-item>
            <span style="display: inline-block;margin-top: 8px;margin-left: 10px;"></span>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('jiaoyijiage')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>交易价格
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.jiaoyijiage" class="input title"></el-input>
            </el-form-item>
            <span style="display: inline-block;margin-top: 8px;margin-left: 10px;"></span>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('jiaoyididian')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>交易地点
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.jiaoyididian" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('youxiaoqixian')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>有效期限
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input
                v-model="form.youxiaoqixian" class="input title"></el-input>
            </el-form-item>
            <span style="display: inline-block;margin-top: 8px;margin-left: 10px;"></span>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>详细说明
          </td>
          <td class="after">
            <div id="kcpupeditor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品图片
          </td>
          <td class="after">
            <el-upload
              v-if="fileList1[0].url"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic1"
              :file-list="fileList1"
              :before-upload="beforeUploadPicture"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic1"
              :before-upload="beforeUploadPicture"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb2')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品图片2
          </td>
          <td class="after">
            <el-upload
              v-if="fileList2[0].url"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :file-list="fileList2"
              :before-upload="beforeUploadPicture"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :before-upload="beforeUploadPicture"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible2">
              <img :src="dialogImageUrl2" />
            </el-dialog>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>主要参数
          </td>
          <td class="after">
            <table class="sub_table1">
              <tr style="background-color: #dfdbdb; font-family: Microsoft YaHei;font-weight: 600;">
                <td>参数名称</td>
                <td>参数值</td>
              </tr>
              <tr>
                <td><el-input v-model="form.n1" class="canshuname"></el-input></td>
                <td><el-input v-model="form.v1" class="canshuvalue"></el-input></td>
              </tr>
              <tr>
                <td><el-input v-model="form.n2" class="canshuname"></el-input></td>
                <td><el-input v-model="form.v2" class="canshuvalue"></el-input></td>
              </tr>
              <tr>
                <td><el-input v-model="form.n3" class="canshuname"></el-input></td>
                <td><el-input v-model="form.v3" class="canshuvalue"></el-input></td>
              </tr>
              <tr>
                <td>例如：规格</td>
                <td>例如：10cm*20cm</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>交易条件
          </td>
          <td class="after">
            <table class="sub_table2">
              <tr>
                <td class="first">计量单位</td>
                <td><el-input v-model="form.unit"></el-input></td>
              </tr>
              <tr>
                <td class="first">产品单价</td>
                <td><el-input v-model="form.price"></el-input>元/单位</td>
              </tr>
              <tr>
                <td class="first">最小起订量</td>
                <td><el-input v-model="form.minamount"></el-input>单位</td>
              </tr>
              <tr>
                <td class="first">供货总量</td>
                <td><el-input v-model="form.amount"></el-input>单位</td>
              </tr>
              <tr>
                <td>发货期限</td>
                <td>自买家付款之日起<el-input v-model="form.days" style="width: 46px;"></el-input>天内发货</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>添加时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
      <div class="btnfixed">
        <el-button type="success" @click="modification">保存</el-button>
        <el-button @click="cancle">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import arrayFun from '@/plugins/app/method/array.js'
import {mapState} from 'vuex'
import E from 'wangeditor'
export default {
  props: ['tjcpID'],
  data()
  {
    return {
      url: '',
      form: {
        typeid: '',
        catid: 0,
        title: '',
        level: '',
        brand: '',
        ssgj: 0,
        xiangmuleibie: '',
        kuangchanzhonglei: '',
        pinwei: '见详细介绍',
        jiaoyiliang: '大量',
        jiaoyijiage: '电议',
        jiaoyididian: '',
        youxiaoqixian: '',
        content: '测试',
        thumb: '',
        thumb2: '',
        n1: '',
        v1: '',
        n2: '',
        v2: '',
        n3: '',
        v3: '',
        unit: '',
        price: '',
        minamount: '',
        amount: '',
        days: '',
        company: '',
        addtime: null,
        edittime: null,
        hits: 0
      },
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //预览弹框
      dialogVisible: false,
      dialogVisible2: false,
      //预览路径
      dialogImageUrl: '',
      dialogImageUrl2: '',
      fileList1: [{url: ''}],
      fileList2: [{url: ''}],
      //级别选项
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      //所属国家选项
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      //表名
      tabname: 'dmcn_sell_23',
      tabContentname: 'dmcn_sell_data_23',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(25, 'catid').then((ret) =>
        {
          this.classifydata = [{ value: 0, label: '选择分类' }]
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
          this.classifydata.sort(arrayFun.compareStoB('value'))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    this.$nextTick(() =>
    {
      const editor = new E('#kcpupeditor')
      // base64 保存图片
      editor.config.uploadImgShowBase64 = true
      // 关闭粘贴样式的过滤
      editor.config.pasteFilterStyle = false
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) =>
      {
        this.form.content = newHtml
      }
      // 隐藏插入网络图片的功能
      // editor.config.showLinkImg = false;
      // 限制大小
      editor.config.uploadImgMaxSize = 12 * 1024 * 1024 // 2M
      // 限制类型
      editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      // 创建编辑器
      editor.create()
      this.editor = editor
    })
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    this.getData()
  },
  methods: {
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 14,
        _exp: 'id=?',
        types: 'i',
        vals: this.tjcpID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.typeid = ret[0].typeid
        this.form.catid = ret[0].catid
        this.form.title = ret[0].title
        this.form.level = ret[0].level
        this.form.brand = ret[0].brand
        this.form.ssgj = ret[0].ssgj
        this.form.xiangmuleibie = ret[0].xiangmuleibie
        this.form.kuangchanzhonglei = ret[0].kuangchanzhonglei
        this.form.pinwei = ret[0].pinwei
        this.form.jiaoyiliang = ret[0].jiaoyiliang
        this.form.jiaoyijiage = ret[0].jiaoyijiage
        this.form.jiaoyididian = ret[0].jiaoyididian
        this.form.youxiaoqixian = ret[0].youxiaoqixian
        this.form.content = ret[0].content
        this.form.thumb = ret[0].thumb
        this.form.thumb2 = ret[0].thumb2
        this.form.n1 = ret[0].n1
        this.form.v1 = ret[0].v1
        this.form.n2 = ret[0].n2
        this.form.v2 = ret[0].v2
        this.form.n3 = ret[0].n3
        this.form.v3 = ret[0].v3
        this.form.unit = ret[0].unit
        this.form.price = ret[0].price
        this.form.minamount = ret[0].minamount
        this.form.amount = ret[0].amount
        this.form.days = ret[0].days
        this.form.company = ret[0].company
        this.form.addtime = ret[0].addtime * 1000
        this.form.edittime = null
        this.form.hits = ret[0].hits
        this.form.thumb = ret[0].thumb
        this.form.thumb2 = ret[0].thumb2
        this.fileList1[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
        this.fileList2[0].url = ret[0].thumb2 !== '' ? ret[0].thumb2 : 'static/images/moren.jpg'
      })
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 15,
        _exp: 'id=?',
        types: 'i',
        vals: this.tjcpID
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.form.content = ret[0].content
        // 重新设置编辑器内容
        this.editor.txt.html(ret[0].content)
      })
    },
    //确定修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 14,
        retAtt: 1,
        id: this.form.id,
        typeid: this.form.typeid,
        catid: this.form.catid,
        title: this.form.title,
        level: this.form.level || 0,
        brand: this.form.brand,
        ssgj: this.form.ssgj,
        kuangchanzhonglei: this.form.kuangchanzhonglei,
        pinwei: this.form.pinwei,
        jiaoyiliang: this.form.jiaoyiliang,
        jiaoyijiage: this.form.jiaoyijiage,
        jiaoyididian: this.form.jiaoyididian,
        youxiaoqixian: this.form.youxiaoqixian,
        content: this.form.content,
        thumb: this.form.thumb,
        thumb2: this.form.thumb2,
        n1: this.form.n1,
        v1: this.form.v1,
        n2: this.form.n2,
        v2: this.form.v2,
        n3: this.form.n3,
        v3: this.form.v3,
        unit: this.form.unit,
        price: this.form.price,
        minamount: this.form.minamount,
        amount: this.form.amount,
        days: this.form.days,
        company: this.form.company,
        addtime: this.form.addtime / 1000,
        edittime: Date.parse(new Date()) / 1000
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 15,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.cancle()
          }
        })
      })
    },
    cancle()
    {
      this.$emit('cancle')
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    onSuccess1(response)
    {
      let that = this
      window.public.onSuccess1(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/qyxx/QyxxUpdate/QyzsCpUpdate.vue